export enum AbTestKeys {
	PlpNewMobileColorSelector = 'plp_new_mobile_color_selector',
	PromoBanner = 'promo_countdown',
	Test = 'test',
	PlpFirstFourSegmentation = 'plp_first_four_segmentation',
	PdpSizesSheet = 'pdp_sizes_sheet',
	NewSearchUi = 'search_new_ui_v3',
	PaymentsKlarnaInstallments = 'payments_klarna_installments',
	SearchInternalService = 'search_internal_service',
	ShoppingCartNoStockProducts = 'shopping_cart__similar_products',
	PaymentsBlinkLogo = 'payments_blink_ab_test',
	KlarnaBenefits = 'payments_klarna_benefits',
	BackInStockNewsletter = 'back_in_stock_newsletter',
}
